<template>
  <div 
  class="d-flex flex-column" style="background: linear-gradient(rgba(0, 114, 206, 0.1), rgba(240, 120, 23, 0.1)); height: 100vh;">
    <div class="d-flex flex-column flex-root align-items-stretch h-100">
      <div
        class="bg-white p-2"
        style="position: fixed; top: 0; left: 0; right: 0; z-index: 1000; width: 100%;">
        <span class="d-flex justify-content-between align-items-center px-10">
          <img :src="event?.logo" width="40px" />
          <div>
            <button class="btn btn-sm btn-light" @click="goHome">{{ $t('button.back') }}</button>
          </div>
        </span>
      </div>

      <div class="d-flex justify-content-center pt-20" style="max-height: 90vh; overflow-y: auto; flex: 1 1 auto; padding-right: 1rem;">
        <div class="my-5" style="width: 90% !important;">
          <div class="card shadow-sm pt-5 px-5">
            <h1 class="mb-10 text-center text-uppercase fs-2hx">{{ $t('events.select_type_form') }}</h1>
            <div class="d-flex flex-wrap justify-content-center">
              <div v-for="(form, index) in event?.forms" :key="index" class="col-auto mb-5 d-flex justify-content-center align-items-center p-5 me-5 text-uppercase rounded-2 bg-hover-primary text-hover-white fw-bold form_style" :class="form.id == formId ? 'bg-primary text-white' : 'bg-light-primary text-primary'" @click="setType(form.id)">
                {{form.name}}
              </div>
            </div>
          </div>
          <div v-if="formId" class="mt-10">
            <FormPreview :steps="formValue?.form?.steps" :eventName="event?.title" @close="goHome" :formId="formId" :note="formValue?.note"/>
          </div>
          <div v-if="!formId" class="mt-10 h-500px d-flex justify-content-center align-items-center" >
            <div class="text-center ">
              <div class="mb-5">
                <img src="@/assets/media/pos/FileEmpty.png" alt=""
                      class="mw-100 h-300px mobile_img" />
              </div>
              <h2 class="fs-2x fw-bolder mb-0" style="margin-top: -50px !important;">{{ $t('events.noData') }}</h2>
            </div>
          </div>
        </div>
      </div>

      <div class="chat_fixed" @click="showForm = !showForm">
        <i class="fa fa-comment"
          :class="showForm ? 'text-primary' : 'text-gray-400'"
          style="font-size: 30px !important;"></i>
      </div>

      <div class="form_fixed card shadow-sm p-5" v-if="showForm">
        <h1 class="text-center mb-5">{{ $t('events.the_questions') }}</h1>
        <Input
          container-class="col-12 form-group mb-5"
          :name="`fullname`"
          type="text"
          :inputClass="'form-control form-control-lg form-control-solid'"
          size="lg"
          :isRequired="true" 
          :placeholder="$t('events.fullname')"
          v-model="formQuestion.name"
        />
        <Input
          container-class="col-12 form-group mb-5"
          :name="`email`"
          type="email"
          :inputClass="'form-control form-control-lg form-control-solid'"
          size="lg"
          :isRequired="true" 
          :placeholder="$t('events.email')"
          v-model="formQuestion.email"
        />
        <textarea
          class="form-control form-control-lg form-control-solid mb-5"
          :placeholder="$t('events.message')"
          rows="6"
          v-model="formQuestion.message"
        ></textarea>
        <Button btn-class="btn-md" type="new" btn-text="button.send" @click="submitQuestion" :is-loading="isLoadingQuestion"></Button>
      </div>

      <div class="footer bg-white py-7" id="kt_footer" style="position: fixed; bottom: 0; left: 0; right: 0; z-index: 1000; width: 100%;">
        <div class="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-center">
          <div class="text-dark order-2 order-md-1 fs-2">
            <span>{{ $t('powered') }}
              <a class="text-hover-primary" target="_blank" href="https://netbyus.com">{{ $t('poweredby') }}</a>
            </span>
            <span class="px-2">©{{ new Date().getFullYear() }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import Button from "@/components/Button";
  import Input from "@/components/Input.vue";
  import { ref, onMounted, watch, computed } from "vue"; 
  import {useStore} from "vuex";
  import {useRoute, useRouter} from "vue-router";
  import {useLocales} from "@/composables/locales";
  import FormPreview from "../../components/FormPreview.vue";
  import GoogleFormRegister from "./GoogleFormRegister.vue";
  import { getTenantId } from '@/mixins/Helpers'

  //const isSenakponTenant = computed(()=> tenant ==="senakpon")
  const store = useStore()
  const route = useRoute()
  const router = useRouter()
  const {locale} = useLocales()

  const showForm = ref(false)
  const event = ref({})
  const isLoadingQuestion = ref(false)
  const formValue = ref([])
  const formId = ref('')
  
  const isSenakponTenant = ref(false)

  const formQuestion = ref({
    name: "",
    email: "",
    message: ""  
  })

  watch(() => formId.value, (value) => {
    if(value){
      showFormData()
    }
  }, { deep: true });

  function setType(item) {
    formId.value = item
  }

  async function showEvent() {
      await store.dispatch('events/getEventDetailForParticipator', route.params.id).then((res) => {
        event.value = res.data?.data
      })
  }

  async function showFormData() {
    await store.dispatch('forms/getEventFormsForParticipator', formId.value).then((res) => {
        formValue.value = res.data?.data
    })
  }

  function submitQuestion() {
    isLoadingQuestion.value = true
    store
        .dispatch('forms/sendContact', formQuestion.value)
        .then(() => {
          showForm.value = false
          window.toastr["success"](i18n.global.t('events.sended_successfully'));
        })
        .catch((e) => {
        }).finally(() => isLoadingQuestion.value = false);
  }

  function goHome() {
    if(event.value.website_link){
      window.location.href = event.value.website_link;
    }else{
      router.push({name: 'event-participator-index'})
    }
  }

  onMounted(() => {
    showEvent()
    isSenakponTenant.value = getTenantId()?.slice(0, -1).toLowerCase() === 'senakpon'
    console.log(getTenantId)
  })
</script>

<style scoped>
  .text-gray {
    color: var(--bs-gray);
  }
  .center_vertical {
    width: 80%;
    margin: 0 auto !important;
    padding-top: 3rem;
  }

  .chat_fixed {
    position: fixed;
    right: 2rem;
    bottom: 7rem;
    cursor: pointer !important;
  }

  .form_fixed {
    position: fixed;
    right: 2rem;
    bottom: 11rem;
    width: 300px; 
    height: 350px;
  }

  .italic-text {
    font-style: italic;
  }

  .btn.btn-orange {
    color: #fff;
    border-color: var(--bs-warning) !important;
    background-color: var(--bs-warning) !important;
  }

  .single-digit {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 50px;
    background-color: rgba(0, 33, 119, 0.3);
    border-radius: 5px;
    padding: 10px;
    color: #fff;
    min-width: 90px !important;
    height: 100px !important;
    position: relative;
  }

  .time-label {
    font-size: 12px !important;
    line-height: 1;
    margin-top: 5px;
    font-weight: 500;
  }

  .time-number {
    font-size: 50px !important;
    line-height: 1;
    font-weight: 500;
  }

  .h1_style {
    font-size: 75px !important; 
    margin-bottom: 2rem;
  }

  .p_style {
    font-size: 20px !important; 
    width: 90% !important;
  }

  .span_style {
    font-size: 10px !important; 
    width: 88% !important;
    margin-bottom: 2rem; 
    cursor: pointer;
    margin-right: 5rem !important;
  }

  .timer {
    width: 200px !important; 
    margin-bottom: 8rem;
  }

  .fs-18 {
    font-size: 18px !important;
  }

  .address {
    margin-bottom: 3rem; 
    display: flex;
  }

  .img_top {
    width: 60px; 
    height: 60px; 
    border-radius: 1rem; 
    margin-bottom: 2rem;
  }

  .img_top img {
    width: 42px;
  }

  .truncate-text {
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .background-container {
    position: relative;
    width: 100%;
    min-height: 100vh;
  }

  .background-container::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 33, 119, 0.45);
    z-index: 0;
  }

  .background-container > * {
    position: relative;
    z-index: 1;
  }

  .form_style {
    font-size: 13px !important;
    cursor: pointer !important; 
    width: 350px !important;
  }

  @media (max-width: 768px) {
    .center_vertical {
      padding-top: 1.5rem !important;
    }

    .h1_style {
      font-size: 30px !important; 
    }

    .p_style {
      font-size: 15px !important;
      width: 100% !important;
    }

    .span_style {
      font-size: 10px !important; 
      width: 100% !important;
    }

    .timer {
      width: 100px !important; 
    }

    .single-digit {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      background-color: rgba(0, 33, 119, 0.3);
      border-radius: 5px;
      padding: 5px;
      color: #fff;
      min-width: 60px !important;
      height: 80px !important;
      position: relative;
    }

    .time-label {
      font-size: 9px !important;
      line-height: 1;
      margin-top: 5px;
    }

    .time-number {
      font-size: 30px !important;
      line-height: 1;
    }

    .fs-18 {
      font-size: 12px !important;
    }

    .address {
      display: block;
    }

    .address .fs-18 {
      font-size: 15px !important;
    }

    .img_top {
      width: 40px; 
      height: 40px; 
      border-radius: 1rem; 
    }

    .img_top img {
      width: 25px;
    }

    .form_style {
      font-size: 10px !important;
      width: 300px !important;
    }

    .mobile_img {
      height: 200px !important;
      margin-top: -80px !important;
      margin-bottom: 10px !important;
    }
  }
</style>